/* Ornamint custom cursor (header setting "Custom cursor"). Loaded by sections/header.liquid only when the setting is on.
   Mouse/trackpad only, never with reduced motion. Dot + trailing ring; grows on links; dark VIEW disc over linked media;
   native cursor over fields/embeds. Also the footer wordmark spotlight. The animation loop runs only while the ring is
   still catching up with the pointer, and stops when it has settled (restarts on the next mouse move). */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  if (mq('(prefers-reduced-motion: reduce)').matches || !mq('(hover: hover) and (pointer: fine)').matches) return;
  if (!html.classList.contains('orn-cursor-on') || html.classList.contains('orn-cursor-live')) return;
  html.classList.add('orn-cursor-live');
  var ring = d.createElement('div'), dot = d.createElement('div');
  ring.className = 'orn-cursor-ring'; dot.className = 'orn-cursor-dot';
  ring.setAttribute('aria-hidden', 'true'); dot.setAttribute('aria-hidden', 'true');
  d.body.appendChild(ring); d.body.appendChild(dot);
  var mx = -99, my = -99, rx = -99, ry = -99, mode = '', running = false;
  var NATIVE = 'input, textarea, select, iframe, [contenteditable], .quick-search__input, .orn-srch__input, .shopify-payment-button, video';
  var setMode = function (m) {
    if (m === mode) return;
    mode = m;
    ring.classList.toggle('is-link', m === 'link');
    ring.classList.toggle('is-view', m === 'view');
    ring.textContent = m === 'view' ? 'VIEW' : '';
    dot.classList.toggle('is-hidden', m === 'view');
  };
  var loop = function () {
    rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
    if (Math.abs(mx - rx) < 0.1 && Math.abs(my - ry) < 0.1) { rx = mx; ry = my; running = false; }
    ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px)';
    dot.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
    if (running) requestAnimationFrame(loop);
  };
  var kick = function () { if (!running) { running = true; requestAnimationFrame(loop); } };
  d.addEventListener('mousemove', function (e) {
    mx = e.clientX; my = e.clientY;
    kick();
    html.classList.add('orn-cursor-in');
    var t = e.target instanceof Element ? e.target : null;
    html.classList.toggle('orn-cursor-native', !!(t && t.closest(NATIVE)));
    var media = t && t.closest('img, picture, .orn-cat__media, .orn-tile__media, .orn-look__img, .product-item__image, .orn-ugc-photo__frame, .orn-price-card__fan') && t.closest('a') && !t.closest('[data-orn-track].is-dragging');
    setMode(media ? 'view' : t && t.closest('a, button, label, summary, [role="button"], [role="tab"]') ? 'link' : '');
  }, { passive: true });
  d.addEventListener('mouseleave', function () { html.classList.remove('orn-cursor-in'); });
  window.addEventListener('blur', function () { html.classList.remove('orn-cursor-in'); });
})();
